import { styled } from '@pata-app/themes';

export const TextWithHighlightContainer = styled.div`
  > * {
    span,
    strong {
      color: ${({ theme }) => theme.core.colors.primary.green.medium};
      font-weight: inherit;
    }
  }
`;
